import React, { forwardRef, HTMLAttributes, RefObject } from 'react';
import classNames from 'classnames';
import './ScrollArea.pcss';

type Props = {
  className?: string;
  children: any;
} & HTMLAttributes<HTMLDivElement>;

export const Component = (
  { className, children, ...rest }: Props,
  ref: RefObject<HTMLDivElement>,
) => {
  return (
    <div
      id="c-scroll-area"
      className={classNames('c-scroll-area', className)}
      ref={ref}
      {...rest}
    >
      {children}
    </div>
  );
};

export const ScrollArea = forwardRef(Component);
